<template>
  <div class="clientes">
    <div class="d-flex justify-content-between">
      <div class="input-group mb-3">
        <button v-on:click="handleAdicionar()" class="btn btn-success">
          <font-awesome-icon :icon="['fas', 'plus']" fixed-width class="me-1"/>Adicionar
        </button>
      </div>

      <div class="input-group mb-3">
        <input
            v-on:keyup.enter="handlePesquisa()"
            type="text"
            class="form-control"
            placeholder="Pesquisar"
            aria-label="Pesquisar"
            aria-describedby="button-addon2">
        <button v-on:click="handlePesquisa()" class="btn btn-outline-secondary" type="button" id="button-addon2">
          <font-awesome-icon :icon="['fas', 'search']" fixed-width class="me-1"/>
        </button>
      </div>
    </div>
    <div class="d-flex justify-content-end">
    </div>
    <div class="d-flex">
      <table class="table table-sm-pc table-striped table-hover">
        <thead>
          <tr>
            <th width="25">#</th>
            <th>Identificação</th>
            <th>IP</th>
            <th>Hardware</th>
            <th width="115"></th>
          </tr>
          </thead>
          <tbody>
            <tr v-for="olt in listaOlts" :key="olt.id" v-bind:class="cssListaOlt(olt)">
              <td scope="row" v-on:click="abreOlt(olt.id)" class="cursor-pointer">{{olt.id}}</td>
              <td v-on:click="abreOlt(olt.id)" class="cursor-pointer">{{olt.descricao}}</td>
              <td v-on:click="abreOlt(olt.id)" class="cursor-pointer">{{olt.ip}}</td>
              <td v-on:click="abreOlt(olt.id)" class="cursor-pointer">{{olt.versao_hardware_olt}}</td>
              <td class="text-end">
                <button type="button" v-on:click="handleEditaOlt(olt)" class="btn btn-primary btn-sm me-1">
                  <font-awesome-icon :icon="['fas', 'edit']" fixed-width/>
                </button>
                <button type="button" v-on:click="handleRemoveOlt(olt)" class="btn btn-danger btn-sm">
                  <font-awesome-icon :icon="['fas', 'times']" fixed-width/>
                </button>
              </td>

            </tr>
          </tbody>
      </table>
    </div>
    <Paginador v-model="paginador" @change-paginacao="onChangePaginacao"/>

    <!-- modal-edita-servidor-olt -->
    <!-- Button trigger modal -->
    <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#modal-edita-servidor-olt" id="btn-modal-edita-servidor-olt-abre">
      Launch
    </button>

    <!-- Modal -->
    <div class="modal fade" id="modal-edita-servidor-olt" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-fullscreen-margin" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 v-if="!modalOlt.data.id" class="modal-title">
              <font-awesome-icon :icon="['fas', 'plus']" fixed-width/>
              Cadastrar nova OLT
            </h5>
            <h5 v-if="!!modalOlt.data.id" class="modal-title">
              <font-awesome-icon :icon="['fas', 'pen']" fixed-width/>
              Editando OLT
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <label class="required">Ativo</label>
                <div class="form-check form-switch">
                  <input v-model="modalOlt.data.ativo" class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
                  <label class="form-check-label" for="flexSwitchCheckDefault"></label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-lg-6">
                <label class="required">Identificação</label>
                <input type="text" v-model="modalOlt.data.descricao" class="form-control">
              </div>
              <div class="col-12 col-sm-6 col-lg-6">
                <label class="required">Endereço IP</label>
                <input type="text" v-model="modalOlt.data.ip" class="form-control">
              </div>
              <div class="col-12 col-sm-4 col-lg-4">
                <label class="required">Porta telnet</label>
                <input type="number" v-model.number="modalOlt.data.porta_telnet" min="0" max="65535" class="form-control">
              </div>
              <div class="col-12 col-sm-4 col-lg-4">
                <label class="required">Usuario telnet</label>
                <input type="text" v-model="modalOlt.data.usuario_telnet" class="form-control">
              </div>
              <div class="col-12 col-sm-4 col-lg-4">
                <label class="required">Senha telnet</label>
                <input type="text" v-model="modalOlt.data.senha_telnet" class="form-control">
              </div>
              <div class="col-12 col-sm-4 col-lg-4">
                <label class="required">Porta SNMP</label>
                <input type="number" v-model.number="modalOlt.data.porta_snmp" min="0" max="65535" class="form-control">
              </div>
              <div class="col-12 col-sm-4 col-lg-4">
                <label class="required">SNMP Community RO</label>
                <input type="text" v-model="modalOlt.data.snmp_community_ro" class="form-control">
              </div>
              <div class="col-12 col-sm-4 col-lg-4">
                <label class="required">SNMP Community RW</label>
                <input type="text" v-model="modalOlt.data.snmp_community_rw" class="form-control">
              </div>
              <div class="col-12 col-sm-6 col-lg-6">
                <label class="required">Versao hardware OLT</label>
                <select
                    v-model="modalOlt.data.versao_hardware_olt"
                    @change="modalOltChangeVersaoHardware"
                    class="form-select">
                  <option disabled value="">Selecione</option>
                  <option
                      v-for="oltHw in olts"
                      :key="oltHw.valor"
                      :value="oltHw.valor">
                    {{oltHw.nome}}
                  </option>
                </select>
              </div>
              <div class="col-12 col-sm-6 col-lg-6">
                <label class="required">Versao software OLT</label>
                <select v-model="modalOlt.data.versao_software_olt" class="form-select">
                  <option disabled value="">Selecione</option>
                  <option
                      v-for="oltSwVersion in versoesSoftwareOlt()"
                      :key="oltSwVersion"
                      :value="oltSwVersion">
                    {{oltSwVersion}}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" id="btn-modal-edita-servidor-olt-fecha">Fechar</button>
            <button type="button"
                v-if="!modalOlt.data.id"
                v-on:click="modalOltCadastrarHandle()"
                v-bind:disabled="!podeSalvarOlt()"
                class="btn btn-success">
              Cadastrar
            </button>
            <button type="button"
                v-if="!!modalOlt.data.id"
                v-on:click="modalOltSalvarHandle()"
                v-bind:disabled="!podeSalvarOlt()"
                class="btn btn-success">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal-edita-servidor-olt -->
  </div>
</template>

<script>
import Paginador from '@/components/Paginador.vue'
import api from '@/modules/api'
import dialogo from '@/modules/dialogo'
import loading from '@/modules/loading'
import clone from '@/modules/clone'
import model from '@/model'

export default {
  name: 'ServidoresOLT',
  components: {
    Paginador,
  },
  data() {
    return {
      /** @type {model.paginador} */
      paginador: clone(model.paginador),
      listaOlts: [],
      listaIPPools: [],
      olts: [
        { valor: "ZTE_C320", nome: "ZTE C320", software: ["2.x",] },
        { valor: "FIBERHOME_5116-06B", nome: "FIBERHOME 5116-06B", software: ["UNK",] },
        { valor: "ZYXEL_OLT2406", nome: "ZyXEL OLT 2406", software: ["V4.02(AAVA.7)C0",] },
      ],
      modalOlt: {
        data: {
          id: undefined,
          descricao: '',
          ip: '',
          porta_telnet: 0,
          usuario_telnet: '',
          senha_telnet: '',
          porta_snmp: 0,
          snmp_community_ro: '',
          snmp_community_rw: '',
          versao_hardware_olt: '',
          versao_software_olt: '',
        },
      }
    }
  },
  methods: {
    carregaIPPools() {
      api.get(`/ip-pools?paginacao.porPagina=-1`).then(res => {
        this.listaIPPools = res.data.itens;
      }).catch(() => {
        setTimeout(() => {
          this.carregaIPPools();
        }, 1000);
      });
    },
    handlePesquisa() {
      loading(true);

      api.get(`/servidores/olt?${this.paginador.requestParams}`).then(res => {
        loading(false);
        this.listaOlts = res.data.itens;
        this.paginador.pagina = res.data.paginacao.pagina;
        this.paginador.totalItens = res.data.paginacao.total;
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    onChangePaginacao() {
      this.handlePesquisa();
    },

    cssListaOlt(olt) {
      const css = [];

      if (!olt.ativo) {
        css.push("text-muted-2");
      }

      return css;
    },

    abreOlt(id) {
      this.$router.push({ path: `/configuracoes/servidores/olts/${id}` });
    },

    handleAdicionar() {
      this.resetmodalOlt();
      this.abreModalCadastroOlt();
    },

    async handleEditaOlt(olt) {
      this.resetmodalOlt();

      this.modalOlt.data = clone(olt);

      this.abreModalCadastroOlt();
    },

    handleRemoveOlt(olt) {
      dialogo.confirmacao(`Confirma remover a OLT <b>${olt.descricao}</b>?`).then(() => {
        loading(true);

        api.delete(`/servidores/olt/${olt.id}`).then(() => {
          loading(false);

          this.handlePesquisa();
        }).catch(error => {
          loading(false);
          dialogo.erroHttp(error);
        });
      });
    },

    abreModalCadastroOlt() {
      document.getElementById('btn-modal-edita-servidor-olt-abre').click();
    },

    resetmodalOlt() {
      this.modalOlt.data.id = undefined;
      this.modalOlt.data.descricao = '';
      this.modalOlt.data.ip = '';
      this.modalOlt.data.porta_telnet = 0;
      this.modalOlt.data.usuario_telnet = '';
      this.modalOlt.data.senha_telnet = '';
      this.modalOlt.data.porta_snmp = 0;
      this.modalOlt.data.snmp_community_ro = '';
      this.modalOlt.data.snmp_community_rw = '';
      this.modalOlt.data.versao_hardware_olt = '';
      this.modalOlt.data.versao_software_olt = '';
    },

    podeSalvarOlt() {
      switch (true) {
        case (this.modalOlt.data.descricao.length < 3):
        case (this.modalOlt.data.ip.length < 7):
        case (this.modalOlt.data.porta_telnet < 1):
        case (this.modalOlt.data.usuario_telnet.length < 1):
        case (this.modalOlt.data.senha_telnet.length < 1):
        case (this.modalOlt.data.porta_snmp < 1):
        case (this.modalOlt.data.snmp_community_ro.length < 1):
        case (this.modalOlt.data.snmp_community_rw.length < 1):
        case (this.modalOlt.data.versao_hardware_olt.length < 1):
        case (this.modalOlt.data.versao_software_olt.length < 1):
          return false;

        default:
          return true;
      }
    },

    modalOltCadastrarHandle() {
      const sendData = {...this.modalOlt.data};

      loading(true);

      api.post('/servidores/olt', sendData).then(() => {
        loading(false);
        document.getElementById('btn-modal-edita-servidor-olt-fecha').click();
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    modalOltSalvarHandle() {
      const sendData = {...this.modalOlt.data};

      sendData.nome = sendData.razao_social;

      loading(true);
      api.put(`/servidores/olt/${sendData.id}`, sendData).then(() => {
        loading(false);
        document.getElementById('btn-modal-edita-servidor-olt-fecha').click();
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    listaIPPoolsPorTipo(tipoIP, tipoGrupo) {
      const resultado = this.listaIPPools.
          filter(x => (x.tipo_ip === tipoIP && x.tipo_grupo === tipoGrupo));

      return resultado;
    },

    versoesSoftwareOlt() {
      const versaoHardware = this.modalOlt.data.versao_hardware_olt;
      const olt = this.olts.find(x => x.valor === versaoHardware);
      const resposta = (olt) ? olt.software : [];

      return resposta;
    },

    modalOltChangeVersaoHardware() {
      this.modalOlt.versao_software_olt = '';
    },
  },

  created() {
    this.handlePesquisa();
    this.carregaIPPools();

    // document.getElementById('btn-modal-edita-servidor-olt-fecha').click();
    /*
    setTimeout(() => {
      this.handleAdicionar();

      this.modalOlt.data.descricao = 'OLT Teste Front';
      this.modalOlt.data.porta_telnet = '123465';
      this.modalOlt.data.usuario_telnet = 0;
      this.modalOlt.data.senha_telnet = 0;
    }, 500);
    /* */
  }
}
</script>
